import { forwardPropsToState } from '../../../utils/react_utils';

const RealizeInputHidden = window.InputHidden;

@forwardPropsToState([{prop: 'value'}])
export default class InputHidden extends RealizeInputHidden {}
